import { currentBuilderState } from '../builder.state';

export function filterPresets(): void {
    const state = currentBuilderState();

    const keyword = (state.presetKeywords ?? '').toLowerCase().trim();

    if (!(keyword?.length > 0)) {
        state.filteredPresets = state.presets;
        return;
    }

    const parts = keyword.split(/\s+/);
    state.filteredPresets = state.presets?.filter((e) =>
        parts.every((p) => e.presetName.toLowerCase().includes(p)),
    );
}
